<script setup>
import { computed, defineProps, defineEmits } from 'vue';

// props + v-model binding
const props = defineProps({
  modelValue: {
    type: String,
    default: null,
  },
  class: {
    type: String,
    default: 'form-control',
  },
});

const emit = defineEmits(['update:modelValue']);

// computed wrapper: ISO <-> local datetime string
const localValue = computed({
  get() {
    if (!props.modelValue) return ''
    const d = new Date(props.modelValue)
    // slice(0,16) trims to "YYYY-MM-DDTHH:mm" for datetime-local
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 16)
  },
  set(val) {
    if (!val) {
      emit('update:modelValue', null)
      return
    }
    // val is "YYYY-MM-DDTHH:mm" in local time → convert to UTC ISO
    const d = new Date(val)
    emit('update:modelValue', d.toISOString())
  }
})
</script>

<template>
  <input
      type="datetime-local"
      v-model="localValue"
      :class="props.class"
  >
</template>
